import React from 'react';
import { connect } from 'react-redux'

import { Table, Row, Col, Button, Dropdown, Pagination } from 'antd';
import { SettingOutlined, DownCircleOutlined, EditOutlined, CloseCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import { _tableLogActivity, getParamTable } from '../../../../lib/Helper';

class Desktop extends React.Component {
  componentDidMount() {
    this.props.fetchTable()
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action
    return (
      <>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Table
              columns={[
                {
                  title: 'No',
                  dataIndex: 'rownum',
                  width: '2%',
                }, {
                  title: 'Tahun Ajaran',
                  dataIndex: 'tahun_ajaran',
                }, {
                  title: 'Tingkatan Kelas',
                  dataIndex: 'tingkatan_kelas',
                  align: 'center',
                }, {
                  title: <SettingOutlined />,
                  align: "center",
                  key: 'operation',
                  width: '2%',
                  render: (a, row) => (!action.detail && !action.update && !action.update ? "-" : <Dropdown trigger={['click']} menu={{
  items: [...(action.detail ? [{
    key: 0,
    label: <Link to={`pemasukan/detail/${row.id}`}><InfoCircleOutlined /> Detail</Link>
  }] : []), ...(action.update ? [{
    key: 1,
    icon: <EditOutlined />,
    label: "Update",
    onClick: this.props.modalForm.bind(this, true, row)
  }] : []), ...(action.delete ? [{
    key: 2,
    icon: <CloseCircleOutlined />,
    label: "Delete",
    onClick: this.props.modalDelete.bind(this, true, row)
  }] : [])]
}}>
                    <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                  </Dropdown>),
                }, {
                  title: 'LogActivity',
                  key: 'operation',
                  width: '10%',
                  render: (a, row) => _tableLogActivity(row),
                },
              ]}
              rowKey={record => record.id}
              dataSource={table.data}
              pagination={false}
              loading={table.loading}
              size="small"
            />
          </Col>
          <Col xs={24} className="table-pagination">
            <Pagination
              size="small"
              current={table.pagination.current}
              pageSize={table.pagination.pageSize}
              total={table.pagination.total}
              showTotal={() => `Total ${table.pagination.total} items`}
              showSizeChanger
              onChange={(current, pageSize) => {
                const pagination = { current: current, pageSize: pageSize, total: table.pagination.total }
                const params = getParamTable("change", table, null, null, pagination)
                this.props.fetch(params)
              }}
            />
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(Desktop);
